import React from 'react';

import { Button, Link, Card } from '@ergeon/core-components';
import whaleSvg from '@ergeon/core-components/src/assets/whale.png';
import { ArrowRightIcon } from '@ergeon/icons/hero/micro';

import Layout from '../../components/Layout';
import Header from '../../components/Header';
import { ROUTES } from '../../routes';

const NotFoundPage = () => {

  return (
    <Layout>
      <Layout.TopBar>
        <Header />
      </Layout.TopBar>
      <Layout.Body>
        <Layout.Content>
          <Card className="flex flex-col justify-center items-center gap-4 h-full">
            <img alt="Error whale" className="-mt-20 size-96" src={whaleSvg} />
            <h1 className="-mt-20 text-gray-900 dark:text-white heading-3">Page Not Found</h1>
            <p className="max-w-md text-gray-600 dark:text-gray-400 text-center paragraph-2">
              Oops! The page you are looking for might have been removed, had its name changed, or is temporarily
              unavailable.
            </p>
            <Link className="contents [&>span]:contents" href={ROUTES.calls.$buildPath({})} unstyled>
              <Button>
                Go to Calls
                <ArrowRightIcon className="size-4" />
              </Button>
            </Link>
          </Card>
        </Layout.Content>
      </Layout.Body>
    </Layout>
  );
};

export default NotFoundPage;
